import React, { createContext, useContext, useMemo, useState } from 'react';
import en from '../locales/en.json';
import es from '../locales/es.json';
import fr from '../locales/fr.json';
import tr from '../locales/tr.json';

// Simple i18n context for the landing page
const LanguageContext = createContext({
	language: 'en',
	setLanguage: () => {},
	t: (key) => key,
	tArray: () => []
});

const translations = { en, es, fr, tr };

const getNestedValue = (object, path) => {
	return path.split('.').reduce((acc, part) => {
		if (acc && Object.prototype.hasOwnProperty.call(acc, part)) {
			return acc[part];
		}
		return undefined;
	}, object);
};

export const LanguageProvider = ({ children }) => {
	const [language, setLanguageState] = useState(() => {
		try { return localStorage.getItem('archon_lang') || 'en'; }
		catch { return 'en'; }
	});
	const setLanguage = (lang) => {
		setLanguageState(lang);
		try { localStorage.setItem('archon_lang', lang); } catch {}
	};
	const activeDictionary = translations[language] || translations.en;

	const t = (path, fallback = '') => {
		const value = getNestedValue(activeDictionary, path);
		if (typeof value === 'string') {
			return value;
		}
		return fallback || path;
	};

	const tArray = (path, fallback = []) => {
		const value = getNestedValue(activeDictionary, path);
		if (Array.isArray(value)) {
			return value;
		}
		return fallback;
	};

	const contextValue = useMemo(
		() => ({ language, setLanguage, t, tArray }),
		[language]
	);

	return (
		<LanguageContext.Provider value={contextValue}>
			{children}
		</LanguageContext.Provider>
	);
};

export const useLanguage = () => useContext(LanguageContext);
